import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import TermsOfServiceModal from './Modal';
import { CONSENT_COPY } from '../../common/data/Constants';

/**
 * Terms of Service acknowledgement (clickwrap).
 *
 * Replaces the required ToS checkbox. A Twilio compliance audit rejected that
 * checkbox for enforcing mandatory consent, and rather than relabel a box the
 * auditor had already objected to, acceptance moves onto the booking action
 * itself: pressing DONE is the assent, and this states what it means.
 *
 * Sits beside the submit button rather than on the contact step, because
 * clickwrap has to be adjacent to the action it binds. The terms remain one
 * click away so that acceptance can be informed.
 *
 * @component
 * @see /docs/REQUIREMENTS.md section 5.1.0
 */
const TermsOfServiceAcknowledgement = (props) => {
  const { classes } = props;

  const [modalOpen, setModalOpen] = useState(false);

  const handleModalOpen = (event) => {
    event.preventDefault();
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  return (
    <div
      className={classes.tosCheckboxContainer}
      data-testid="tos-acknowledgement"
    >
      <Typography variant="caption" color="textSecondary" display="block">
        {CONSENT_COPY.TOS_ACKNOWLEDGEMENT}{' '}
        {/*
          Rendered as a MUI Link with component="button" so it carries the
          BUTTON role, not LINK -- it opens a modal rather than navigating.
        */}
        <Link
          component="button"
          variant="caption"
          onClick={handleModalOpen}
          className={classes.tosLink}
        >
          {CONSENT_COPY.TOS_LINK_TEXT}
        </Link>
        .
      </Typography>
      <TermsOfServiceModal open={modalOpen} onClose={handleModalClose} />
    </div>
  );
};

TermsOfServiceAcknowledgement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles((theme) => theme.termsOfService)(
  TermsOfServiceAcknowledgement,
);
